import ApiError from './ApiError';

/**
 * @typedef {Function} ApiFunction
 * @param {string} url
 * @param {string} method
 * @param {string|object} data
 * @param {...any} other
 * @returns {object|string}
 */

/**
 * @param {string} options.baseUrl
 * @param {authorization} options.authorization
 * @returns {ApiFunction}
 */
const createApi =
  ({ baseUrl, authorization }) =>
  async (url, { method = 'GET', data, silentError = false, ...other } = {}) => {
    try {
      const { href } = new URL(url, baseUrl);

      const options = {
        ...other,
        method,
        headers: {
          'content-type': 'application/json',
          'x-api-version': '2.0',
          authorization,
          ...other?.headers,
        },
        body: typeof data === 'object' ? JSON.stringify(data) : data,
      };

      if (method === 'GET') delete options.body;

      const response = await fetch(href, options);

      let result;
      try {
        result = await response.clone().json();
        // eslint-disable-next-line no-underscore-dangle
        if (result._embedded) {
          // eslint-disable-next-line no-underscore-dangle
          result = result._embedded;
        }
      } catch {
        try {
          result = await response.text();
        } catch {
          result = undefined;
        }
      }

      if (![200, 201].includes(response.status)) {
        throw new ApiError(`Error calling api ${href}`, response, result);
      }

      return result;
    } catch (error) {
      if (silentError) {
        error.silent = silentError;
      }
      throw error;
    }
  };

export default createApi;
